import type { Partner } from "@expert/shared-types";

import type { ChannelShareData } from "../customer-info/types";

export function shouldShowCallIntroFlowQuestions(partner: Partner, callDetails: ChannelShareData): boolean {
    return partner !== "youtubetv" || (partner === "youtubetv" && callDetails?.CLIENT !== "ASURION_CARE_STREAMING");
}
